import { AbstractType, InjectionToken, Injector, Type } from '@angular/core';

let rootInjector: Injector | undefined;

export function setRootInjector(injector: Injector): void {
  rootInjector = injector;
}

export function getRootInjector<T>(
  token: Type<T> | AbstractType<T> | InjectionToken<T>,
): T {
  if (!rootInjector) {
    throw new Error('Root injector not initialized');
  }
  return rootInjector.get(token);
}
